<template>
  <section class="preview">
    <form novalidate @submit.prevent="crear">
      

      

       <mdb-input
        type="text"
        label="Nombre"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="coloca el nombre"
      ></mdb-input>

      <mdb-input
        label="Id de cuenta"
        class="mb-3 mt-0"
        v-model="account_id"
        required
        invalidFeedback="Coloca el codigo"
      ></mdb-input>


      <mdb-input
        label="Nombre Business"
        class="mb-3 mt-0"
        v-model="business_name"
        required
        invalidFeedback="Coloca el codigo"
      ></mdb-input>
      


      <div class="form-group">
        <label class="typo__label">Partner</label>
        <multiselect
          v-model="partner"

          placeholder="Seleccione una cuenta "
          label="name"
          track-by="id"

          :options="partners"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>


      <div class="form-group">
        <label class="typo__label">Cuenta Business</label>
        <multiselect
          v-model="business_account"
          placeholder="Seleccione una cuenta "
          label="name"
          track-by="id"
          :options="business_accounts"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>


      <div class="form-group">
        <label class="typo__label">Estatus</label>
        <multiselect
          v-model="account_status"
          placeholder="Seleccione el País"
          label="name"
          track-by="value"
          :options="accounts_status"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>
      <!--<label>Estrategias</label>
      <multiselect
        v-model="strategyActionsSelected"
        placeholder="Estrategias de acción"
        class="mb-3"
        label="name"
        track-by="id"
        :options="strategyActions"
        :multiple="true"
      ></multiselect>-->


      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>



<script>
import { mdbInput, mdbBtn } from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";

import Multiselect from "vue-multiselect";
import store from "../../store";
export default {
  name: "modal-2",
  components: {
    mdbInput,
    Multiselect,
    mdbBtn,
    SemipolarSpinner,
    
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      is_value_based:false,
      name: "",
      business_name:"",
      partner:{},
      partners:[],
      account_id:"",
      account_status:{},
      business_account_id:"",
      business_account:[],
      business_accounts:[],
      partner:[],
      partners:[],
      accounts_status:[
          {name:"ACTIVE",value:"1"},
          {name:"DISABLED",value:"2"},
          {name:"UNSETTLED",value:"3"},
          {name:"PENDING_RISK_REVIEW",value:"7"},
          {name:"PENDING_SETTLEMENT",value:"8"},
          {name:"IN_GRACE_PERIOD",value:"9"},
          {name:"PENDING_CLOSURE",value:"100"},
          {name:"CLOSED",value:"101"},
          {name:"ANY_ACTIVE",value:"201"},
          {name:"ANY_CLOSED",value:"202"},
      ]
    };
  },
  async mounted() {
    await this.getBusiness();
     await this.getPartners();

  },
  methods: {
    getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        store.dispatch("getPartners").then(() => {
          partners = store.getters.getPartners;

          this.partners = partners;

        });
      } else {
        this.partners = partners;
      }
    },

    getBusiness() {
      var business = store.getters.getBusiness;
      if (business.length == 0) {
        store.dispatch("getBusiness").then(() => {
          business = store.getters.getBusiness;
          this.business_accounts = business;
        });
      } else {
        this.business_accounts = business;
      }
    },

    crear(event) {
      event.target.classList.add("was-validated");
      var { 
        name,
      account_id,
      account_status,

      business_name,

      partner
      } = this;
      this.isLoading = true;
      if (
          name == "" ||
          account_id == "" ||

          account_status == {} ||
          business_account == {} ||
          partner == {}

          ) {
        this.isLoading = false;
      } else {
        var adsAccount = {
          name,
          account_id,
          account_status,
          business_account,
          partner
        };
        store.dispatch("newAdsAccount", adsAccount).then(() => {
          this.name=""
          this.account_id=""
          this.account_status={}
          this.onClick();
          this.isLoading = false;
        });
      }
    },
    
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
</style>